import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BenachrichtigungUebersichtComponent } from './benachrichtigung-uebersicht/benachrichtigung-uebersicht.component';

const routes: Routes = [{ path: '', component: BenachrichtigungUebersichtComponent }];

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class BenachrichtigungenRoutingModule {}
